import Barcode from "react-barcode";

interface PropsType {
    barcode: string
    options?: BarcodeGeneratorOptionsType
}

interface BarcodeGeneratorOptionsType {
    format?: "CODE39" | "CODE128" | "CODE128A" | "CODE128B" | "CODE128C" | "EAN13" | "EAN8" | "EAN5" | "EAN2" | "UPC" | "UPCE" | "ITF14" | "ITF" | "MSI" | "MSI10" | "MSI11" | "MSI1010" | "MSI1110" | "pharmacode" | "codabar" | "GenericBarcode" | undefined;
    width?: number;
    height?: number;
    displayValue?: boolean;
    text?: string;
    fontOptions?: string;
    font?: string;
    textAlign?: 'left' | 'center' | 'right';
    textPosition?: 'top' | 'bottom';
    textMargin?: number;
    fontSize?: number;
    background?: string;
    lineColor?: string;
    margin?: number;
    marginTop?: number;
    marginBottom?: number;
    marginLeft?: number;
    marginRight?: number;
    flat?: boolean;
    valid?: (valid: boolean) => void;
}

export default function BarcodeGenerator({
                                             barcode,
                                             options
                                         }: PropsType) {
    return barcode ? <Barcode value={barcode} font={"Spoqa Han Sans Neo"} {...options}/> : <></>
}